import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";

import { TopNav } from "./top-nav";
import { default as FootInfo } from "./foot-info";

@observer
class DefaultLayout extends Component {
  //===========================================================================

  @observable drawerOpen = false;
  //===========================================================================

  render() {
    const { children } = this.props;
    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        handleSendMsg: this.handleSendMsg,
        handelConfirm: this.confirmAlert
      })
    );
    return (
      <Fragment>
        <div id="wrap">
          <TopNav drawerOpen={this.drawerOpen} onOpen={this.open} />
          <div id="maincontents">{childrenWithProps}</div>
          <FootInfo drawerOpen={this.drawerOpen} onClose={this.close} />
        </div>
      </Fragment>
    );
  }
  //===========================================================================

  /**
   * 드로워 열고 닫기 메소드
   */
  @action
  open = () => {
    this.drawerOpen = true;
  };
  @action
  close = () => {
    this.drawerOpen = false;
  };
  //===========================================================================
}

export default DefaultLayout;
